<template>
  <div class="page flex-col">
    <div class="mod4 flex-col">
      <div :class="isFull ? 'outer1 outer1full' : 'outer1'" ref="outer">
        <div
          class="toptitle flex-row align-center justify-between"
          style="padding: 0px"
        >
          <div style="display: flex; align-items: center">
            <div
              class="flexstartcenter marginRight cursonpinter"
              @click="$router.go(-1)"
            >
              <img
                src="@/assets/detail/left.png"
                style="width: 16px; height: 16px; margin-right: 5px"
              />
              <span style="font-size: 14px; color: #fff">返回 </span>
            </div>
            <el-popover placement="bottom-start" width="300" trigger="click">
              <div style="display: flex; flex-direction: column">
                <span
                  style="font-size: 18px; color: #666; margin-bottom: 10px"
                  >{{ bookDetail.bookName }}</span
                >
                <span style="font-size: 14px"
                  >作者:{{ bookDetail.charger }}</span
                >
                <span>分类:{{ bookDetail.categoryName }}</span>
                <span>版本:{{ bookDetail.bookVersion }}</span>
                <span>{{ bookDetail.printing }}</span>
                <span style="color: #999">{{ bookDetail.description }}</span>
                <div style="display: flex; justify-content: flex-end">
                  <el-button @click="toDetail" type="text">更多>></el-button>
                </div>
              </div>
              <div slot="reference" class="info3">
                <img
                  class="icon1"
                  referrerpolicy="no-referrer"
                  src="@/assets/img/icon_detail.png"
                /><span>書目詳情</span>
              </div>
            </el-popover>
          </div>
          <!-- {{
              this.pageList && this.pageList.length > 0
                ? "/" + this.pageList[0].catalogName
                : ""
            }} -->
          <span class="title"
            >{{ title }}{{ nowCatalogName ? "/" + nowCatalogName : "" }} /第{{
              readPage
            }}页(共{{ totalPage }}页)</span
          >
          <div class="fullscreen" style="width: 100px">
            <img
              v-if="isFull"
              src="@/assets/img/canselfull1.png"
              @click="changefull(2)"
            />
            <img v-else src="@/assets/img/full1.png" @click="changefull(1)" />
          </div>
          <!-- <el-dropdown
            @command="changecat"
            placement="bottom-end"
            trigger="click"
          >
            <div class="el-dropdown-link">
              <img
                class="icon2"
                referrerpolicy="no-referrer"
                src="@/assets/img/icon_item.png"
              /><span>目录</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in catalogueList"
                :key="item.id"
                :command="item.id"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown> -->

          <!-- <span class="txt3">跳转至&nbsp;</span>
          <input
            class="regis_inp"
            @keyup.enter.stop="onSubmit"
            size="mini"
            type="number"
            style="
              width: 30px;
              margin-left: 5px;
              margin-right: 5px;
              text-align: center;
            "
            v-model="currentPage"
          />
          <span class="word6">页</span> rebuild-->
        </div>
        <div class="viewerbox">
          <viewer
            ref="viewer"
            :options="options"
            @inited="inited"
            :images="pageList"
          >
            <img
              style="display: none; margin-top: 24px"
              v-for="item in pageList"
              :src="baseUrl + item.fileUrl"
              :alt="item.bookPage"
              :key="item.bookPage"
            />
          </viewer>
          <div class="slisdbox" ref="slisd" v-show="!isFull">
            <slisd
              :key="alisdkey"
              :min="1"
              :max="totalPage"
              :value="readPage"
              :isDrag="true"
              bgColor="#4ab157"
              @presspage="presspage"
            ></slisd>
          </div>
        </div>

        <!-- <div class="lefticon" @click="changepageleft">
          <img src="../assets/img/left-circle.png" alt="" />
        </div>
        <div class="righticon" @click="changepageright">
          <img src="../assets/img/right-circle.png" alt="" />
        </div> -->
        <!-- pageList[this.readPage - 1] && pageList[this.readPage - 1].remark -->
        <!-- 提示栏 -->
        <!-- position: absolute;
            left: 50%;
            bottom: 75px;
            z-index: 9999999; -->

        <div
          v-show="
            isShowRemark &&
            pageList[this.readPage - 1] &&
            pageList[this.readPage - 1].remark
          "
          class="animate__animated animate__fadeInRight"
          style="
            position: absolute;
            top: 30px;
            right: 0px;
            display: flex;
            flex-direction: column;
            background-color: #ffffff;
            height: 40vh;
            min-width: 200px;
          "
        >
          <div class="remarkcontent">
            <img src="/static/icon/zhu.jpg" alt="" />
            <div class="content">
              <p>
                {{
                  pageList[this.readPage - 1] &&
                  pageList[this.readPage - 1].remark
                }}
              </p>
            </div>
          </div>
          <div class="remarkhref">
            <div
              class="left"
              v-show="pageList[readPage - 1] && pageList[readPage - 1].jumpTo"
              @click="
                jumpNew(pageList[readPage - 1] && pageList[readPage - 1].jumpTo)
              "
            >
              <img src="/static/icon/pull_right.png" alt="" /><span>跳轉</span>
            </div>
            <div class="right" @click="isShowRemark = false">
              <img src="/static/icon/hulue.png" alt="" /><span>忽略</span>
            </div>
          </div>
        </div>

        <div
          v-show="
            !isShowRemark &&
            pageList[this.readPage - 1] &&
            pageList[this.readPage - 1].remark
          "
          @click="isShowRemark = true"
          style="
            position: absolute;
            top: 30px;
            right: 0px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #211f1f;
            height: 40vh;
            width: 20px;
            cursor: pointer;
          "
        >
          <img src="/static/icon/arrows_left.png" alt="" />
          <span style="font-size: 16px; color: white">注</span>
        </div>
        <div class="navpagebox" :style="{ height: isFull ? '90px' : '50px' }">
          <selpaginate
            style="text-align: center"
            v-show="isFull"
            :pageNo="readPage"
            :page-size="1"
            :total="totalPage"
            :continues="7"
            :start="startNum"
            :end="endNum"
            @getPageNo="handleCurrentChange"
            @changeStartEnd="changeNum"
            :class="isFull ? 'pagiself' : ''"
          >
          </selpaginate>
          <!-- <el-pagination
            :pager-count="9"
            :style="
              !isFull
                ? 'text-align: center; display:none'
                : 'text-align: center;'
            "
            @current-change="handleCurrentChange"
            :page-size="1"
            :current-page="readPage"
            layout="prev, pager, next, jumper"
            :total="totalPage"
            :class="isFull ? 'pagiself' : ''"
          >
          </el-pagination> -->
          <div
            class="navbar"
            ref="navbar"
            :style="{
              position: isFull ? 'absolute' : '',
              bottom: '0',
              left: '0',
            }"
          >
            <ul class="navlist">
              <li
                v-for="(item, index) in pageList"
                :key="index"
                @click="navCurrentChange(index)"
                :class="index == readPage - 1 ? 'viewer-active' : ''"
              >
                <img
                  :src="
                    item.fileThumb
                      ? baseUrl + item.fileThumb
                      : baseUrl + item.fileUrl
                  "
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <el-pagination
        :pager-count="9"
        :style="
          isFull
            ? 'text-align: center; display:none'
            : 'text-align: center; margin-top:10px;'
        "
        @current-change="handleCurrentChange"
        :page-size="1"
        :current-page="readPage"
        layout="prev, pager, next, jumper,->"
        :total="totalPage"
        :class="isFull ? 'pagiself' : ''"
      >
      </el-pagination> -->
      <selpaginate
        :style="
          isFull ? 'text-align: center;' : 'text-align: center; margin:10px 0;'
        "
        v-show="!isFull"
        :pageNo="readPage"
        :page-size="1"
        :total="totalPage"
        :continues="7"
        :start="startNum"
        :end="endNum"
        @getPageNo="handleCurrentChange"
        @changeStartEnd="changeNum"
      >
      </selpaginate>

      <div class="mulu" ref="mulu">
        <div class="mulutop">
          <img src="@/assets/img/icon_item.png" /><span>卷冊</span>
        </div>

        <div class="celist">
          <div class="ceitems">
            <div
              class="ce"
              v-for="(catdetail, index) in catalogueList"
              v-if="
                index >= catalogueparam.start && index <= catalogueparam.end
              "
              :key="catdetail.catalogId"
            >
              <el-button
                @click="
                  changecat(catdetail.catalogId, index, catdetail.catalogName)
                "
                :type="catId == catdetail.catalogId ? 'primary' : ''"
                size="mini"
                style="margin-left: 10px"
                >{{ catdetail.catalogName }}</el-button
              >
              <!-- :type="
                  (muluactive || muluactive == '0') && muluactive == index
                    ? 'primary'
                    : ''
                "
                @click="chengeMulu(index)" -->
              <el-button
                @click="
                  chengeMulu(catdetail.catalogId, index, catdetail.catalogName)
                "
                :type="
                  catId == catdetail.catalogId && isShowMulu ? 'primary' : ''
                "
                size="mini"
                style="margin-left: 10px"
                >目錄</el-button
              >
            </div>
          </div>
          <el-pagination
            small
            :current-page="catalogueparam.pageNum"
            layout="prev, pager, next"
            @current-change="getPageNum"
            :page-size="catalogueparam.pageSize"
            :total="catalogueparam.total"
          >
          </el-pagination>
          <div class="mulutop" v-if="isShowMulu">
            <img src="@/assets/img/icon_item.png" /><span>目錄</span>
          </div>
          <div class="newmulu" v-if="isShowMulu">
            <ul>
              <li
                v-for="child in catalogueList[muluactive].children"
                :key="child.catalogId"
              >
                {{ child.catalogName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Swiper from "../swiper"
import merge from 'webpack-merge'
// import imgview from '../components/image-viewer.vue'
import selpaginate from '../components/selpagination.vue'
import {
  read,
  bookInfo,
  bookPage,
  essearch,
  booksTree,
  getBookCatalogue
} from '@/api/api'
// import $ from 'jquery'
// import textPage from './com/textPage.vue'
// import imagePage from './com/imagePage.vue'
// import noData from './com/noData.vue'
import slisd from '../components/progress.vue'
export default {
  components: {
    // textPage,
    // imagePage,
    // noData,
    // imgview,
    slisd,
    selpaginate
    //Paginate
  },
  data () {
    return {
      startNum: 1,
      endNum: 7,
      // fullobj: {},
      alisdkey: 0,
      ratio: 0,
      isFull: false,
      isShowRemark: false,
      isShowMulu: false,
      muluactive: 0,
      drawer: true,
      baseUrl: window.__baseUrl__,
      isEdit: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      catalogueList: [], //目录数据
      nowCatalogName: "",//当前章
      axis: 'both', //拖动方向限制
      x: 0,
      y: 0,
      pb: '豎排',
      fy: '分页',
      zoom: 100,
      searchList: [],
      isLoading: false,
      pageList: [],
      form: {
        pageNum: 1,
        pageSize: 20,
        bookId: this.$route.query.id,
        bookText: ''
      },
      currentPage: 0,
      bookDetail: {},
      constants: {},
      title: '',
      mode: 1,
      page0: {},
      page1: {},
      bookId: 0,
      catId: 0,
      readPage: 0,
      totalPage: 0,
      img: "",
      singleType: 0,
      searchIndex: '',
      jumpTo: 0,
      remark: '',
      tooltipKey: 1,
      treeNode: [],
      // isDragEnd: true,//进度条
      // percentage: 50
      // pressper: 0.01,
      totalNew: 0,
      pageNumNew: 1,
      pageSizeNew: 10,
      imageList: [],
      $viewer: {},
      options: {
        name: 'dd',
        toolbar: {
          prev: true,
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          play: false,
          next: true,
        },
        loop: false,
        // toolbar: true,
        navbar: false,
        movable: true,
        inline: true,
        button: false,
        transition: true,
        rotatable: false, //旋转
        scalable: false, //翻转
        fullscreen: true,
        title: false,
        className: 'center',
        slideOnTouch: false,
        view: this.viewsel,
        viewed: this.viewed,
        show: this.showsel,
        zoom: this.zoomself,
        play: this.fullbuttonclick,
        // inheritedAttributes: ['crossOrigin', 'decoding', 'isMap', 'loading', 'referrerPolicy', 'srcset', 'useMap']
      },
      catalogueparam: {
        total: 8,
        pageNum: 1,
        pageSize: 8,
        start: 0,
        end: 7
      },

    }
  },
  created () {
    // let fullobj = document.querySelector(".viewer-fullscreen")
    // let fullobj = document.querySelector(".viewer-fullscreen")
    // fullobj.addEventListener('click', function () {
    //   // console.log(this.viewer === viewer)
    //   // > true
    //   console.log('play')
    // })
    // fullobj.onclick = this.fullbuttonclick()
    // console.log(fullobj, 'fullobj')
    // 为日历添加点击事件，需要在页面渲染完后
    // console.log(this.$refs.fullbutton, 'ffull')


  },
  computed: {
    // dataChange () {
    //   const { bookDetail, catalogueList } = this
    //   return { bookDetail, catalogueList }
    // }

  },
  mounted () {
    this.bookId = this.$route.query.id
    //书籍信息
    // this.getBooksTree(this.bookId)
    this.getBookInfo(this.bookId)
    this.getBookCatalogue()

    this.catId = this.$route.query.catId
    // this.totalPage = parseInt(this.$route.query.totalPage)
    this.readPage = parseInt(this.$route.query.page)
    this.currentPage = this.readPage
    // this.initPage()
    this.$bus.$on("presspage", (per) => {
      this.presspage(per)
    })


    // let fullbutton = document.querySelector('.viewer-button')
    // console.log(fullbutton, 'fullbutton')
    // .addEventListener('click', this.fullbuttonclick)
    // this.$viewer.view(1)
    // this.$bus.$on('buschangepage', (index) => {
    //   console.log('buschangepage', index)
    // })


    // image.addEventListener('viewed', function () {
    //   // console.log(this.viewer === viewer)
    //   // > true
    // })

    // this.viewer.addEventListener('play', function () {
    //   // console.log(this.viewer === viewer)
    //   // > true
    //   console.log('play')
    // })

  },
  methods: {
    changeNum (start, end) {
      // console.log(start, end, 'start,end')
      this.startNum = start
      this.endNum = end
    },
    clickCallback (pageNum) {
      console.log(pageNum)
    },
    changefull (type) {
      // console.log('xxx')

      if (type == 1) {
        this.isFull = true
        this.$refs.outer.style.position = "fixed"
        this.$refs.outer.style.height = "100%"
        // this.$refs.slisd.style.display = 'none'

        document.querySelector(".viewerbox").style.width = "100%"
        document.querySelector(".viewerbox").style.height = '85vh'
        document.querySelector(".viewer-container").style.width = "100%"
        document.querySelector(".viewer-container").style.height = '100%'
        // document.querySelector(".viewer-move").style.height = '100%'
        // document.querySelector(".viewer-container").classList.add("viewer-fixed")
        // document.querySelector(".viewer-container").style.position = 'fixed'

        // document.querySelector(".viewer-container").style.right = '0'
        // document.querySelector(".viewer-move").style.height = "80%"
        // document.querySelector(".viewer-move").style.width = "auto"
        // this.$viewer.zoomTo(.8)

        // this.$viewer.zoomTo(.6, {
        //   x: window.innerWidth / 2,
        //   y: this.$viewer.innerHeight / 2,
        // })

        // this.$viewer.moveTo(window.innerWidth / 2 - 220, 40)

        // let imgdom = document.querySelector(".viewer-move").getBoundingClientRect()
        // console.log(imgdom, 'imgdom')
        // let imgdom = document.querySelector(".viewer-move").getBoundingClientRect()
        // this.$viewer.moveTo(window.innerWidth / 2 - imgdom.width, 40)
        // this.$viewer.move(-imgdom.width, 0)
        // this.$viewer.inited()
        // console.log(imgdom, 'imgdom')
        // document.querySelector(".viewer-move").style.marginTop = "40px"
        // this.options.className = 'center viewer-fixed'
        // this.$refs.mulu.style.display = "none"
        // this.$viewer.full()

        // this.$viewer.view(this.readPage - 1)
        // this.$viewer.initImage()
        this.$viewer.resize()
        //  document.querySelector(".viewer-toolbar").innerHTML=``
      } else {
        this.isFull = false
        this.$refs.outer.style.position = "relative"
        this.$refs.outer.style.height = ""
        this.$refs.slisd.style.display = 'block'
        this.$refs.mulu.style.display = "block"



        document.querySelector(".viewerbox").style.height = '54vh'
        document.querySelector(".viewer-container").style.width = "100%"
        document.querySelector(".viewer-container").style.height = '100%'
        document.querySelector(".viewer-container").style.height = '100%'
        this.alisdkey += 1
        // this.readPage = this.readPage - 1
        // document.querySelector(".viewer-move").style.height = '100%'

        // let outerdom = this.$refs.outer.getBoundingClientRect()
        // this.$viewer.zoomTo(.36, {
        //   x: window.innerWidth / 2,
        //   y: this.$viewer.innerHeight / 2,
        // })

        // this.$viewer.moveTo(outerdom.width / 2 - 110, 40)
        // this.$viewer.view(this.readPage - 1)
        this.$viewer.resize()


        // this.options.className = 'center viewer-fixed'
        // this.$viewer.exit()
      }
      this.navjump(this.readPage - 1)

    },
    fullbuttonclick () {
      console.log('clic')
    },
    chengeMulu (catalogId, index, cname = '') {
      // if (this.muluactive !== '' && index == this.muluactive) {
      //   this.isShowMulu = false
      //   this.muluactive = ''
      // } else {
      //   this.isShowMulu = true
      //   this.muluactive = index
      // }

      if (index != this.muluactive) {
        this.changecat(catalogId, index, cname)
        this.isShowMulu = true
      } else {
        this.isShowMulu = !this.isShowMulu
      }




    },
    getPageNum (page) {
      // console.log(page, 'page')
      this.catalogueparam.start = (page - 1) * this.catalogueparam.pageSize
      this.catalogueparam.end = page * this.catalogueparam.pageSize - 1

    },
    getBookCatalogue () {
      getBookCatalogue({
        parentId: 0,
        bookId: this.bookId
      }).then(res => {
        // console.log(res, 'res')

        this.catalogueList = res.data
        this.catalogueparam.total = res.data.length
        if (!this.$route.query.catId) this.catId = this.catalogueList[0].catalogId
        res.data.forEach((item) => {
          if (item.catalogId == this.catId) {
            this.nowCatalogName = item.catalogName
          }
        })
        this.initPage()
      })
    },
    writeRead () {
      read({
        bookId: this.bookId,
        readPage: this.readPage,
        catalogId: this.catId
        // remark: JSON.stringify({ catId: this.catId }),
        // params: { catId: this.catId }
      })
    },
    inited (viewer) {
      this.$viewer = viewer
      this.navjump(0)
      // this.$viewer.view(0)

    },
    viewsel (e) {
      // console.log(e,'1')
      // this.$viewer.options.zoomRatio = this.ratio
      // e.detail.image.width = 1000
      // this.$viewer.imageData.ratio =1
      // this.$viewer.toggle()

      //this.$viewer.renderImage()
      // console.log(this.$viewer.imageData)
      // this.$viewer.imageData.width = this.$viewer.imageData.naturalWidth * this.ratio
      // this.$viewer.imageData.height = this.$viewer.imageData.naturalHeight * this.ratio
      // this.$viewer.imageData.oldRatio = this.$viewer.imageData.ratio
      // this.$viewer.imageData.ratio = this.ratio
      // this.$viewer.show()
      // this.$viewer.renderImage()
      // this.$viewer.viewed = true
      // if (this.ratio > 0) {
      //   // this.$viewer.zoomTo(this.ratio)
      //   this.$viewer.rotateTo(this.ratio)
      //   // this.$viewer.zoomTo(e.detail.oldRatio)
      // }

      // if (this.ratio > 0) {
      //   this.$viewer.zoomTo(this.ratio)
      //   // this.$viewer.zoomTo(e.detail.oldRatio)
      // }

    },
    showsel (e) {
      // console.log(e, e.type)
    },
    readysel () {
      // console.log('readysel')


    },
    viewed (e) {
      if (this.ratio > 0) {
        this.$viewer.zoomTo(this.ratio)
      }
      // this.$viewer.loadImage()
      // this.$viewer.scale(0.9); 
      this.readPage = e.detail.index + 1
      this.currentPage = e.detail.index + 1
      this.navjump(this.readPage - 1)
    },
    // hide (e) {
    //   console.log('hede')
    // },
    zoomself (e) {
      // console.log(e, 'xxx')
      this.ratio = e.detail.ratio

      // this.options.initialCoverage =  this.options.initialCoverage + this.ratio
      // this.$viewer.setDefaults({ className: 'selwidth' })
      // this.zoom(options.zoomRatio, true)

    },
    playself (e) {
      console.log(e, 330)
    },
    fullself () {
      console.log(999)
    },
    changepage () {
      console.log('changge')
    },
    changecat (command, index, catalogName = '') {
      // this.$message('click on item ' + command)
      // console.log(command, 'catId')
      this.catId = command
      this.readPage = 1
      this.currentPage = 1
      this.muluactive = index
      // this.catalogueList.forEach((item, index) => {
      //   if (item.id == command) {
      //     this.totalPage = item.endPage
      //   }
      // })
      // this.nowCatalogName = this.catalogueList[index].catalogName
      this.nowCatalogName = catalogName
      // this.catalogueList.forEach((item) => {
      //   if (item.catalogId == this.catId) {
      //     this.nowCatalogName = item.catalogName
      //   }
      // })
      this.initPage()
    },
    getBookInfo (bookId) {
      bookInfo({
        bookId
      }).then(res => {
        // console.log(res, 'res')
        this.bookDetail = res.data
        this.title = res.data.bookName
        // this.totalPage = res.data.totalPage

      })

    },
    toDetail () {
      this.$router.push({
        path: '/detail',
        query: this.$route.query
      })
    },
    // jump () {
    //   let routeUrl = this.$router.resolve({
    //     path: "/view",
    //     query: {
    //       id: this.bookId,
    //       page: this.jumpTo
    //     }
    //   })
    //   window.open(routeUrl.href, '_blank')
    // },
    loadNode (node, resolve) {
      console.log(node)
      if (node.level === 0) {
        return resolve([{
          name: '正在加载数据'
        }])
      }
      let parentId = node.data.id
      let nodeType = node.data.nodeType
      booksTree({
        parentId: parentId,
        nodeType: nodeType
      }).then(res => {
        resolve(res.data)
      })
    },
    // getBooksTree (id) {
    //   booksTree({
    //     parentId: id,
    //     nodeType: 'book',
    //   }).then(res => {
    //     console.log(res, 'bokktre')
    //     this.catalogueList = res.data
    //   })
    // },
    handleNodeClick (e, e1) {
      console.log(e, e1)
      this.currentPage = e.beginPage
      this.onSubmit()
    },
    onDrag: function (x, y) {
      if (!this.isEdit) {
        if (this.fy === '连续') {
          //如果是连续模式 不能往下拖拽
          return y <= 0
        }
      } else {
        return false
      }
    },
    onDragstop () {
      this.tooltipKey++
    },
    dragging: function (x, y) {
      this.y = y
      this.x = x
      // if (this.fy === '连续' && this.mode === 3) {
      // if (this.$refs.table.clientHeight / 3 * 2 < Math.abs(this.y)) {
      // this.pageList.push(this.pageList[0])
      // }
      // }
    },
    fd (event) {
      let obj = this.$refs.table
      return this.tableZoom(obj, {
        wheelDelta: 100
      })
    },
    sx (event) {
      let obj = this.$refs.table
      return this.tableZoom(obj, {
        wheelDelta: -100
      })
    },
    // 缩放回正
    xx () {
      let obj = this.$refs.table
      obj.style.zoom = "100%"
      this.zoom = 100
      this.x = 0
      this.y = 0
    },
    //开启编辑模式
    bj () {
      this.xx()
      this.isEdit = !this.isEdit
    },
    handleTableWheel (event) {
      let obj = this.$refs.table
      return this.tableZoom(obj, event)
    },
    centerScare (event, dom, zoom) {
      console.log(dom.offsetLeft)
      var ratioL = (event.clientX - dom.offsetLeft) / dom.offsetWidth
      var ratioT = (event.clientY - dom.offsetTop) / dom.offsetHeight
      var ratioDelta = zoom / 100
      var w = parseInt(dom.offsetWidth * ratioDelta)
      var h = parseInt(dom.offsetHeight * ratioDelta)
      var l = Math.round(event.clientX - (w * ratioL))
      var t = Math.round(event.clientY - (h * ratioT))
      // with(dom.style) {
      //     width = w +'px';
      //     height = h +'px';
      //     left = l +'px';
      //     top = t +'px';
      // }
      console.log(l)
      this.x = l
      this.y = t
      if (zoom > 0) {
        dom.style.zoom = zoom + "%"
      }
    },
    tableZoom (obj, event) {
      if (this.fy === '连续' || this.isEdit) {
        return
      }
      // 一开始默认是100%
      this.zoom = parseInt(obj.style.zoom, 10) || 100
      // 滚轮滚一下wheelDelta的值增加或减少120
      this.zoom += event.wheelDelta / 12
      if (this.zoom > 0) {
        obj.style.zoom = this.zoom + "%"
      }
      return false
    },
    handleCommand (command) {
      this.pb = command
    },
    handleCommand1 (command) {
      if (command === '连续') {
        this.xx()
        this.axis = 'y'
      } else {
        this.xx()
        this.axis = 'both'
      }
      this.fy = command
      this.initPage()
    },
    switchSingle (type) {
      this.singleType = type
      this.initPage()
    },
    singleChange () {
      this.readPage = this.readPage + 1
      this.initPage()
    },
    change (e) {
      essearch(this.form).then((res) => {
        this.searchIndex = ''
        this.searchList = res.data
      })
    },
    setMode: function (mode) {
      this.xx()
      this.mode = mode
      if (mode === 1 || mode === 3) {
        this.singleType = 0
        if (mode === 1) {
          this.handleCommand('豎排')
          this.handleCommand1('分页')
        }
        if (mode === 3) {
          this.handleCommand('豎排')
          this.handleCommand1('分页')
        }
      } else if (mode === 2) {
        this.handleCommand1('分页')
      }
    },
    changepageleft () {
      // totalNew: 0,
      // pageNumNew: 1,
      // pageSizeNew: 19
      if (this.pageNumNew == 1) {
        this.$message({
          message: '已经是第一页',
          type: 'warning'
        })
        return false
      }

      this.pageNumNew = this.pageNumNew - 1
      this.readPage = this.pageSizeNew * (this.pageNumNew - 1) + 1
      this.currentPage = this.readPage
      this.fenzu(this.readPage, (this.readPage + this.pageSizeNew - 1))
    },
    changepageright () {
      if (this.pageNumNew == this.totalNew) {
        this.$message({
          message: '已经是最后一页',
          type: 'warning'
        })
        return false
      }
      this.readPage = this.pageSizeNew * this.pageNumNew + 1
      this.pageNumNew = this.pageNumNew + 1

      this.currentPage = this.readPage
      this.fenzu(this.readPage, (this.readPage + this.pageSizeNew - 1))
    },

    prevPage: function () {
      if (this.readPage == 1) {
        alert('已经是第一页')
        return false
      }
      this.readPage = this.readPage - 1 - this.singleType
      this.currentPage = this.readPage
      this.initPage()
    },
    nextPage: function () {
      if (this.readPage == this.totalPage) {
        alert('已经是最后一页')
        return false
      }
      this.readPage = this.readPage + 1 + this.singleType
      this.currentPage = this.readPage
      this.initPage()
    },
    presspage (perobj) {
      // console.log(perobj, 'perobj')
      if (perobj.type == 1) {
        let per = perobj.val
        let tempage = Math.ceil(this.totalPage * per / 100)

        console.log(tempage, this.totalPage, 'tempage')
        if (tempage <= this.totalPage && tempage > 0) {
          // this.pressper = Math.round(per) / 100
          this.readPage = tempage
          this.currentPage = tempage
          // this.initPage()
          this.$viewer.view(this.readPage)
          this.writeRead()

        } else {
          console.log(111)
        }

      } else {
        let tempage = perobj.val
        if (tempage <= this.totalPage && tempage > 0) {
          // this.pressper = Math.round(per) / 100
          this.readPage = tempage
          this.currentPage = tempage
          this.$viewer.view(this.readPage - 1)
          this.writeRead()
          // this.initPage()

        } else {
          console.log(2222222)
        }

      }
      this.handleCurrentChange(this.readPage)

      this.$bus.$emit("startNumAndEndNum1", this.readPage)
    },
    handleCurrentChange (tempage) {

      this.readPage = tempage
      this.currentPage = tempage
      this.$viewer.view(this.readPage - 1)
      this.writeRead()
      this.navjump(tempage - 1)
    },
    // nextClick (e) {
    //   console.log(e, 'eedd')
    // },

    navCurrentChange (index) {
      this.readPage = index + 1
      this.currentPage = index + 1
      this.$viewer.view(index)
      this.writeRead()
      this.navjump(index)
      this.$bus.$emit("startNumAndEndNum1", this.readPage)
    },
    navjump (index) {
      let navdom = document.querySelector(".navlist")
      // getBoundingClientRect().width
      let outwidth = this.$refs.outer.getBoundingClientRect().width
      navdom.style.marginLeft = (outwidth / 2 - index * 33) + 'px'


    },
    toPageNum: function (index, e) {
      this.searchIndex = index
      this.currentPage = e
      this.onSubmit()
    },
    onSubmit () {
      const pageNum = parseInt(this.currentPage)
      if (pageNum <= this.totalPage && pageNum >= 0) {
        this.readPage = pageNum
        this.$viewer.view(pageNum - 1)
        this.writeRead()

      } else {
        console.log(333333333)
      }
    },
    jumpNew (page) {
      console.log(page, 'page')
      this.currentPage = page
      this.readPage = page
      this.$viewer.view(page - 1)
      this.writeRead()

    },
    initPage () {
      // if (parseInt(this.$route.query.page) != parseInt(this.readPage) || parseInt(this.$route.query.catId) != parseInt(this.catId)) {
      //   this.$router.push({
      //     query: merge({}, {
      //       id: this.$route.query.id,
      //       page: this.readPage,
      //       catId: this.catId,
      //       // totalPage: this.totalPage
      //     })
      //   })
      // }
      this.isLoading = true
      this.pageList = []
      let readPage = this.readPage
      let bookId = this.bookId

      //书页信息
      // console.log(this.totalPage, 'this.totalPage')

      bookPage({
        bookId,
        // catalogId: this.catalogueList[0].id,
        catalogId: this.catId,
        // startPage: readPage,
        // endPage: readPage + 9
        startPage: 1,
        endPage: 1000
      }).then(res => {
        // console.log(res, 'res')
        this.pageList = res.data
        this.totalPage = res.data.length
        // this.$nextTick(() => {
        // console.log(document.getElementById("viewerTitle3"), 'dfsf')
        this.isLoading = false
        // })

      })
      //阅读记录

      this.writeRead()
    },
    fenzu (start = 1, end = 10) {
      if (parseInt(this.$route.query.page) != parseInt(this.readPage)) {
        this.$router.push({
          query: merge({}, {
            id: this.$route.query.id,
            page: this.readPage,
            catId: this.catId,
            totalPage: this.totalPage
          })
        })
      }
      this.imageList = []
      this.pageList.forEach((ele, index) => {
        if (index >= start && index <= end) {
          this.imageList.push(ele)
        }
      })

    }
  },
  watch: {
    // catalogueList (newVal, oldVal) {
    //   console.log(newVal, 'newVal')
    //   if (JSON.stringify(this.bookDetail) != '{}' && (newVal.length != 0 && this.pageList == 0)) {


    //   }

    // }
    // catId: {
    //   handler (newval, oldval) {

    //     if (newval) {
    //       console.log(newval, 'catId')
    //       this.initPage()
    //     }
    //   },
    //   immediate: true
    // }
  }
};
</script>
<style lang="less" scoped>
// /deep/.viewer-canvas > img{
//   // transition: width 1s;
//   display: none;
// }
// /deep/.viewer-footer {
//   background-color: #000;
// }
// /deep/.el-button:focus {
//   // color: #409eff;
//   // border-color: #c6e2ff;
//   // background-color: #ecf5ff;
//   background-color: #fff;
//   border-color: #dcdfe6;
//   color: #606266;
// }
/deep/.el-button {
  max-width: 256px;
  white-space: pre-wrap;
  text-align: left;
  line-height: 1.5;
}
/deep/.viewer-transition {
  // transition: all 0.08s;
  transition: all 0.25s linear;
}
.pagination {
  display: flex;
}
.page-item {
  width: 20px;
}
.navbar {
  // margin-top: 50px;
  width: 100%;
  height: 50px;
  overflow: hidden;
  .navlist {
    transition: all 0.3s;
    display: flex;
    width: 100%;
    margin-left: 0px;
    // overflow: hidden;
    .viewer-active {
      opacity: 1;
    }
    li {
      transition: opacity 0.15s;
      color: transparent;
      opacity: 0.5;
      margin-left: 1px;
    }
    li :hover {
      opacity: 0.8;
    }
    img {
      cursor: pointer;
      width: 32px;
      height: 50px;
    }
  }
}
.fullscreen {
  cursor: pointer;
  text-align: center;
  img {
    width: 16px;
    height: 16px;
  }
}
/deep/.pagiself .btn-next,
/deep/.pagiself .btn-prev {
  background: center center no-repeat;
}
/deep/.pagiself .el-pager li {
  background: none;
  font-size: 14px;
  color: #fff;
}
/deep/.pagiself .el-pager li.active {
  color: #409eff;
}
/deep/.pagiself .btn-next .el-icon,
/deep/.pagiself .btn-prev .el-icon {
  font-size: 14px;
  color: #fff;
}
/deep/.pagiself button,
/deep/ .pagiself span:not([class*="suffix"]) {
  color: #fff;
  font-size: 13px;
}
/deep/.pagiself .el-pagination__editor.el-input .el-input__inner {
  height: 24px;
}

/deep/.outer1full {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
}
/deep/.viewer-canvas > img {
  height: 0px;
}
// /deep/.viewer-navbar {
//   overflow: visible;
// }
.flexstartcenter {
  display: flex;
  align-items: center;
}
.marginRight {
  margin-right: 10px;
}
.cursonpinter {
  cursor: pointer;
}
.remarkcontent {
  padding: 20px;
  display: flex;
  height: 90%;
  justify-content: space-between;
  .content {
    // flex: 1;
    // width: 150px;
    // overflow-y: scroll;
  }
  img {
    width: 39px;
    height: 85px;
    margin-right: 10px;
  }
  P {
    padding: 0;
    margin: 0;
    font-size: 16px;
    writing-mode: vertical-rl;
    text-align: justify;
  }
}
.remarkhref {
  width: 100%;
  height: 10%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 12px;
  }
  .left {
    cursor: pointer;
    display: flex;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .right {
    cursor: pointer;
    display: flex;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
/deep/.el-pagination {
  padding: 0;
  text-align: right;
  // margin-top: 10px;
}
.mulu {
  height: 16vh;
  // background-color: pink;
  padding: 16px 0;
  overflow-y: auto;

  .mulutop {
    display: flex;
    align-items: center;
    img {
      height: 15px;
      width: auto;
    }
    span {
      font-size: 15px;
    }
  }
  .newmulu {
    // margin-top: 10px;
    padding: 10px 0 30px;
    ul {
      width: 89%;
      display: flex;
      flex-wrap: wrap;
      li {
        font-size: 15px;
        margin: 5px 20px;
      }
    }
  }
  .celist {
    // height: 16vh;
    // background-color: white;
    .ceitems {
      display: flex;
      flex-wrap: wrap;
    }

    width: 100%;
    // display: flex;
    // flex-wrap: wrap;
    // padding-bottom: 20px;
    // justify-content: flex-start;
    cursor: pointer;
    padding: 0;
    margin: 0;
    .ce {
      width: 25%;
      font-size: 16px;
      // margin: 10px 80px 10px 10px;
      padding: 10px;
      display: flex;
      align-items: flex-start;
      align-items: center;
      // flex-wrap: wrap;
    }
  }
}

/deep/.viewer-toolbar > ul {
  margin-bottom: 20px;
}
/deep/.el-dropdown-link {
  cursor: pointer;
  display: flex;
  img {
    margin-right: 4px;
  }
}
/deep/.el-dropdown-menu {
  left: 123px;
}
.slisdbox {
  width: 99%;
  // height: 10px;
  // background-color: #fff;
  position: absolute;
  left: 0.5%;
  // top: 90%;
  bottom: 5px;
  z-index: 9999999;
}
.lefticon {
  width: 24px;
  height: 40px;
  cursor: pointer;
  // background-color: #fff;
  // background: url("../assets/img/left-circle.png") 24px 24px no-repeat;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9999999;
  img {
    width: 24px;
    height: 24px;
  }
}
.righticon {
  width: 24px;
  height: 40px;
  cursor: pointer;
  // background-color: #fff;
  // background: url("../assets/img/left-circle.png") 24px 24px no-repeat;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 9999999;
  img {
    width: 24px;
    height: 24px;
  }
}
// /deep/.viewer-navbar {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// }
// /deep/.viewer-navbar::before {
//   content: "";
//   display: block;
//   height: 100%;
//   width: 24px;
//   height: 44px;
//   background-color: #fff;
// }
// /deep/.viewer-navbar::after {
//   content: "";
//   display: block;
//   height: 100%;
//   width: 24px;
//   height: 44px;
//   background-color: #fff;
// }
// /deep/.viewer-transition {
//   margin: 0 auto;
//   // transform: translateX(0px);
// }

/deep/.viewer-backdrop {
  background-color: #000;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cline {
  width: 1px;
  background-color: #dddddd;
  height: 20px;
}

.btnview {
  background-color: white;
  margin-left: 10px;
  display: flex;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  align-items: center;
  font-size: 16px;
}

.btnview i {
  cursor: pointer;
  font-size: 18px;
  margin-left: 5px;
}

.btnview .text1 {
  font-size: 15px;
  padding: 5px 13px 5px 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/*在谷歌下移除input[number]的上下箭头*/
.regis_inp[type="number"]::-webkit-outer-spin-button,
.regis_inp[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.regis_inp[type="number"] {
  -moz-appearance: textfield;
}

#read_left {
  justify-content: center;
  /* background: #454545; */
}

#read_right {
  /* background: #454545; */
}

.page_left {
  width: 1.2rem;
  height: 1.2rem;
  background: url("../assets/img/left-circle.png") -0.027rem 0rem no-repeat;
  background-size: 1.227rem 1.2rem;
  margin-top: 8.4rem;
}

.page_left:hover {
  opacity: 0.79;
}

.page_right {
  width: 1.2rem;
  height: 1.2rem;
  background: url("../assets/img/right-circle.png") -0.027rem 0rem no-repeat;
  background-size: 1.227rem 1.2rem;
  margin: 8.4rem 0 0 1.174rem;
}

.page_right:hover {
  opacity: 0.79;
}

.reader {
  display: flex;
  justify-content: center;
  width: 940px;
}

.title {
  text-align: center;
  // width: 100%;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  // color: #454545;
  // padding-top: 20px;
  // margin-bottom: 20px;
  // transform: translateX(50%);
}

.txt {
  cursor: pointer;
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;

  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.107rem;
}

.selected {
  color: rgba(170, 29, 31, 1);
}

.page {
  /* position: relative; */
  /* height: 24.5rem; */
  /* background-color: rgba(245, 245, 245, 1); */
  /* width: 100%;
  height: 100vh; */
  overflow: hidden;
  margin: 0 auto;
  flex: 1;
  /* padding-bottom: 40px; */
}

.mod1 {
  width: 38.4rem;
  height: 31.094rem;
  background: none;
}

.group1 {
  height: 2.08rem;
  background-color: rgba(255, 255, 255, 1);
  width: 38.4rem;
  padding: 0.507rem 0 0 2.987rem;
}

.mod2 {
  width: 32.214rem;
  height: 1.307rem;
}

.layer1 {
  width: 4.534rem;
  height: 1.307rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4763fecae4f3dbd33fedecbd4a2e0fc03f75b4cd8e9d4e000fe793b5c88589d4)
    0.187rem 0rem no-repeat;
  background-size: 4.347rem 1.334rem;
}

.word1 {
  width: 0.88rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 4.08rem;
}

.layer2 {
  height: 0.827rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6bf1dc9e05e2fcfc42219f92ddbe5dd7fc853ba61295d528ec2d1b0b07003555)
    100% no-repeat;
  width: 3.467rem;
  margin: 0.134rem 0 0 1.734rem;
  padding: 0.16rem 0 0 0.88rem;
}

.word2 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.info1 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.827rem;
}

.txt1 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.494rem;
}

.word3 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.52rem;
}

.layer3 {
  width: 0.427rem;
  height: 0.587rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5618ba96d6e45c5af5d14cae1dcfca8615fc726c6816559d10f2f2d325c1d304)
    100% no-repeat;
  margin: 0.24rem 0 0 6.214rem;
}

.word4 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.214rem;
}

.layer4 {
  width: 0.027rem;
  height: 0.427rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng292e16e315659a9700abfa430c040d1419bc4573dc009e320d08121fccd7eb1f)
    0rem 0rem no-repeat;
  background-size: 0.027rem 0.454rem;
  margin: 0.347rem 0 0 0.294rem;
}

.txt2 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.294rem;
}

.group2 {
  height: 11.44rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngad5f0d35d719a5e8e532d9026a1423ccdd763d660c0787a153fa85932c23e026)
    100% no-repeat;
  margin-top: 15.44rem;
  width: 38.4rem;
  padding: 9.947rem 0 0 4.96rem;
}

.main1 {
  width: 28.507rem;
  height: 1.2rem;
}

.bd1 {
  width: 1.2rem;
  height: 1.2rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge3125e1fc5229687835ef1bb1c8f431df5ba316107180da69c8893505d0c8003) -0.027rem
    0rem no-repeat;
  background-size: 1.227rem 1.2rem;
}

.bd2 {
  width: 1.227rem;
  height: 1.2rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb173a475c29d15dfd512d2213c03d6a9e9b45b18bbae395d371db5f9417b3cdc)
    0rem 0rem no-repeat;
  background-size: 1.254rem 1.2rem;
}

.group3 {
  width: 38.4rem;
  height: 0.134rem;
  background-color: rgba(170, 29, 31, 1);
}

.group4 {
  z-index: 27;
  height: 2rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2dc70e2dd957c588ff9bfdb344f8935d1e22f4b76f2bdd7091a344d1f294119c)
    100% no-repeat;
  width: 38.4rem;
  position: relative;
  padding: 0.747rem 0 0 16.187rem;
}

.info2 {
  z-index: 30;
  position: static;
  left: 16.187rem;
  top: 29.84rem;
  width: 6.054rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.373rem;
  font-family: PingFangTC-Regular;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.pic1 {
  z-index: 28;
  position: absolute;
  left: 0;
  top: 0;
  width: 38.4rem;
  height: 2rem;
}

.mod3 {
  z-index: 35;
  position: absolute;
  left: 3.174rem;
  top: 4.907rem;
  width: 32.054rem;
  height: 0.027rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng807f03c8acf303d3672039d68217b70e430607d422e7d6ad54239c27283bb827)
    100% no-repeat;
}

.mod4 {
  overflow: hidden;
  z-index: 99;
  /* height: 22.5rem; */
  background-color: #ffffff;
  background-size: 32.054rem 24.32rem;
  // width: 32rem;
  width: 37.33rem;
  // width: 100%;
  /* position: absolute;
  left: 3.2rem;
  top: 1.014rem; */
}
.toptitle {
  width: 100%;
  height: 40px;
  padding: 0px;
  // position: absolute;
  // left: 0px;
  // top: 0px;
  background-color: #000;
  z-index: 9;
}
.outer1 {
  /* width: 30.774rem; */
  /* height: 22.854rem; */
  position: relative;
  width: 100%;
  /* height: 24rem; */
  //height: 60vh;
  height: auto;
  background-color: #000;
}
.viewerbox {
  width: 100%;
  height: 54vh;
  position: relative;
}

.outer2 {
  width: 30.72rem;
  height: 0.56rem;
}

.icon1 {
  width: 16px;
  height: 16px;
  // margin-top: 0.027rem;
}

.info3 {
  cursor: pointer;
  width: 1.494rem;
  margin-top: 1px;
  // height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  // color: rgba(69, 69, 69, 1);
  color: #fff;
  font-size: 14px;
  white-space: nowrap;
  // line-height: 0.534rem;
  text-align: left;
  margin-left: 0.16rem;
  display: flex;
  align-items: center;
  img {
    margin-right: 5px;
  }
}

.icon2 {
  width: 0.427rem;
  height: 0.4rem;
  margin: 0.08rem 0 0 0.694rem;
}

.word5-1 {
  cursor: pointer;
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.134rem;
}

.txt3 {
  width: 1.12rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.72rem;
}

.layer5 {
  width: 0.694rem;
  height: 0.534rem;
  border-radius: 2px;
  border: 1px solid rgba(219, 219, 219, 1);
  background-color: rgba(255, 255, 255, 1);
  margin: 0.027rem 0 0 0.267rem;
}

.word6 {
  width: 0.374rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.267rem;
}

.label1 {
  width: 0.427rem;
  height: 0.427rem;
  margin: 0.054rem 0 0 0.694rem;
}

.txt4 {
  cursor: pointer;
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.134rem;
}

.label2 {
  width: 0.427rem;
  height: 0.427rem;
  margin: 0.054rem 0 0 0.694rem;
}

.word7 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.16rem;
}

.icon3 {
  width: 0.507rem;
  height: 0.507rem;
}

.icon4 {
  width: 0.507rem;
  height: 0.507rem;
  margin-left: 0.64rem;
}

.word8 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.107rem;
}

.label3 {
  width: 0.507rem;
  height: 0.507rem;
  margin: 0.027rem 0 0 0.694rem;
}

.word9 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin-left: 0.054rem;
}

.info4 {
  width: 12.054rem;
  height: 0.88rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.64rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.88rem;
  text-align: left;
  margin: 1.707rem 0 0 9.387rem;
}

.outer3 {
  z-index: 126;
  border-radius: 9px;
  /* background-color: #f3f3f3; */
  background-color: #000;

  width: 32rem;
  position: relative;
  margin: 0.854rem 0 0 0.08rem;
}

.layer6 {
  width: 28.48rem;
}

.mod6 {
  height: 18rem;
}

.layer7 {
  z-index: 155;
  position: absolute;
  left: 25.787rem;
  top: 0.64rem;
  width: 4.294rem;
  height: 0.934rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge55d32415b421fdafb717bb2c31efdfc36dd5d901a1df38b9980e793460aaee2) -0.027rem -0.027rem
    no-repeat;
  background-size: 4.347rem 0.987rem;
}

.layer8 {
  z-index: 154;
  position: absolute;
  left: 15.04rem;
  top: 0.427rem;
  width: 11.947rem;
  height: 18rem;
  border: 2px solid rgba(235, 235, 235, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/view.vue